import React, { Fragment } from 'react';
import './PortalAppPermission.scss';
import { PERMISSION_MAP } from "../../helpers/PortalPermission";
import DefaultConfig from '../../config/default';
import { Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useEffect, useState } from "react";
import UserAnalytic from '../../helpers/UserAnalytic';

const CanChangeLoginPermission = (currentVAccount, permissions) => {
    return false;
}

const PortalAppPermission = ({
    user, maxPermission,
    permissions, handleUpdateUserPortalPermission,
    currentVAccount
}) => {
    const [ formData, setFormData ] = useState(null);
    const appPermission = PERMISSION_MAP[DefaultConfig.DOMAIN_NAME] || [];
    const handleSelectValue = (key, value) => {
        setFormData({
            ...formData,
            [key]: (value === 'true')
        });
    };
    const handleUpdateBtn = (e) => {
        if (e) {
            e.target.blur();
        }
        const newPerm = Object.keys(formData).reduce((memo, key) => ({
            ...memo,
            [key]: Boolean(formData[key])
        }), {});
        // console.log('handleUpdateBtn', user, newPerm);
        handleUpdateUserPortalPermission(newPerm);
        UserAnalytic.event({
            category: 'user_security_permission',
            action: 'Update user permission',
        });
    };
    useEffect(() => {
        const perm = {...permissions, ...formData};
        setFormData(perm);
    }, [permissions]);
    const safeFormData = formData || {};
    const canChangeLoginPermission = true;
    // can change for
    // Main vAccount if no other chapels are enable
    // Chapel vAccount if main vAccount is enable
    // TODO: Get all permissions of all chapels and parent vAccount
    // const canChangeLoginPermission = CanChangeLoginPermission(currentVAccount, permissions);
    return (
        <>
            <Row>
                <Col>
                    <Button variant="primary" onClick={handleUpdateBtn}>Save</Button>
                </Col>
            </Row>
            {appPermission.map((item, idx) => {
                if (item.isUsable && !item.isUsable(currentVAccount)) {
                    return <Fragment key={idx}></Fragment>;
                }
                const itemValue = safeFormData[item.key];
                return (
                    <Row key={idx} className="permission-field g-0 pt-2 pb-2">
                        <Col className="p-2 fw-bold" lg={4}>{item.label}</Col>
                        <Col lg={4}>
                            <Form.Select
                                disabled={user.isBusinessOwner || (
                                    item.key === 'login' && !canChangeLoginPermission
                                )}
                                onChange={(e) => handleSelectValue(item.key, e.target.value)}
                                value={itemValue}>
                                {
                                    item.choice.map((v, idx) => (
                                        <option key={idx} value={v.value}>{v.label}</option>
                                    ))
                                }
                            </Form.Select>
                        </Col>
                        <Col lg={4}>
                            {item.goToTabOption && (
                                <>
                                    {safeFormData && permissions && safeFormData[item.key] != permissions[item.key] && safeFormData[item.key] === true ?
                                        <span className="text-danger d-block px-2 py-0 m-0">Save first to configure</span> : null
                                    }
                                    <Button
                                        variant="link"
                                        onClick={() => document.getElementById(item.goToTabOption.tabName).click()}
                                        disabled={permissions && !permissions[item.key]}
                                    >{item.goToTabOption.label}</Button>
                                </>
                            )}
                            {!itemValue && currentVAccount && !currentVAccount.parentEntityId && item.key === 'login' ? (
                                <div className='px-1'>
                                    <Alert variant="warning" className="p-2 m-0">
                                        Disabling access to the main account will disable access to all chapels.
                                    </Alert>
                                </div>
                            ) : null}
                        </Col>
                    </Row>
                );
            })}
        </>
    );
};

export default PortalAppPermission;
